<display-form [displayObject]="sharedDetail" [displayFields]="sharedDetailDisplayFields"></display-form>
<hr class="mt-3 mb-3" />
<generic-search-results [showHeader]="false" [showCounter]="false" [title]="''" [records]="invitedGuestsData"
    [displayedColumns]="invitedGuestsDataDisplayFields" [selectableRecords]="false" [sortable]="true"
    [allowLocalFilter]="false"></generic-search-results>